// Canonical localStorage keys for the Web auth surface (QA-UX-001).
// Single definition shared by api.ts and auth-coordination.ts.
// RCC uses its own namespaced keys (rcc/src/lib/auth.ts) — do NOT share.
export const ACCESS_KEY = 'realityai_token';
export const REFRESH_KEY = 'realityai_refresh';
